import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getAdminNotificationsApi } from "../../api/notification.js";
import NotificationList from "../../component/NotificationList.js";
import Container from "../../component/Container.js";
import Popup from "../../component/popup/Popup.js";

const Card = ({ iconSrc, title, onClick }) => (
    <Box
        sx={{
            boxShadow: "0px 1px 6px 0px #00000040",
            borderRadius: "10px",
            height: "100%",
            backgroundColor: "#FAFAFA",
            display: "flex",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: "0px 8px 12px 0px #00000040",
            },
        }}
        onClick={onClick}
    >
        <Box
            sx={{
                borderRadius: "10px 0 0 10px",
                background: "#9E9E9E",
                width: "200px",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <img src={iconSrc} style={{ height: "70px" }} alt={title.toLowerCase()} />
        </Box>
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexGrow: 1,
            }}
        >
            <Typography variant="h3">{title}</Typography>
        </Box>
    </Box>
);

const SystemAdminPage = () => {
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [noticePopup, setNoticePopup] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const getNotifications = async () => {
        const response = await getAdminNotificationsApi();
        if (response?.data) {
            setNotifications(response.data);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getNotifications();
    }, []);

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    gap: 2,
                    justifyContent: "space-between",
                }}
            >
                <Box
                    sx={{
                        flex: 1.2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        justifyContent: "center",
                    }}
                >
                    <Card
                        iconSrc={"assets/icons/users.svg"}
                        title="User Management"
                        onClick={() => navigate(`/modules/UserManagement`)}
                    />
                    <Card
                        iconSrc={"assets/icons/project.svg"}
                        title="Project Management"
                        onClick={() => navigate(`/modules/ProjectManagement`)}
                    />
                </Box>
                <Container
                    title="Notification"
                    icon="assets/icons/notification.svg"
                    buttonIcon="assets/icons/whiteexpand.svg"
                    onClick={() => setNoticePopup(true)}
                    isLoading={isLoading && notifications.length === 0}
                    sx={{ flex: 1 }}
                >
                    <NotificationList notifications={notifications} />
                </Container>
            </Box>
            <Popup
                title="Notification"
                open={noticePopup}
                setOpen={setNoticePopup}
                onClose={() => setNoticePopup(false)}
                modalStyle={{
                    "& .MuiBox-root.css-ft9d2q": {
                        borderRadius: "10px 10px 0 0",
                    },
                }}
                popupStyle={{
                    minWidth: 750,
                }}
            >
                <Box sx={{ py: 2, px: 4, maxHeight: "500px", overflow: "auto" }}>
                    <NotificationList notifications={notifications} />
                </Box>
            </Popup>
        </>
    );
};

export default SystemAdminPage;
